<template>
  <div class="pb-3">
    <div class="v-card__title greytxt--text pa-0">
      <h5>{{field.label}}</h5>
    </div>
    <codemirror v-model="newValue" :options="cmOptions" />
  </div>
</template>
<script>

//language syntax highlight
import 'codemirror/mode/htmlmixed/htmlmixed.js'

//black theme
import 'codemirror/theme/mbo.css'

export default {
  name: 'CodeEditorField',
  props: ['field', 'value'],
  data: function () {
    return {
      newValue: this.value,
      cmOptions: {
        tabSize: 4,
        textSize: 5,
        lineNumbers: true,
        line: false,
        lineWrapping: true,
        mode: 'htmlmixed',
        theme: 'mbo'
      }
    }
  },
  watch: {
    newValue (val) {
      this.$emit('input', val == '' ? null : val)
    }
  }
}
</script>